import axios from 'axios';

const coreApi = axios.create({
	baseURL: 'https://gamarent.contacarweb.cl/core/index.php/', // local
	timeout: 120 * 1000, // n * miliseconds
	// headers: {'Access-Control-Allow-Origin': '*'}
});

const getJObject = (dataVector) => JSON.stringify(dataVector.reduce(
	    (total, currentValue, currentIndex) => {
	        return Object.assign(total, {
	            [currentIndex]: currentValue
	        })
	    },
		{}
	));;


const callApi = async (url, dataVector) => {
	const jObject = getJObject(dataVector);
	const response = await coreApi.get(url, {
		params: {
			jObject,
		},
	});
	return response;
}


export const consultaReservaCheckin = async (dataVector) => {
	return await callApi('cls_res_cki/fnc_csu_res_cki', dataVector);
}

const conditionApiResponse = (res) => res.status === 200 && res.data.data !== null && res.data.data.length > 0;

const handleApiCall = (path, dataVector, handleSuccess, handleError) => {
    callApi(path,dataVector)
		.then((r) => {
			if(conditionApiResponse(r)){
			  handleSuccess(r);
			}
		})
		.catch((e) => {
			handleError(e);
			console.log('Error: ', e);
		});
};

const handleFormApiCall = (path, formData, dataVector, handleSuccess, handleError) => {
	const jObject = getJObject(dataVector);
    coreApi.post(path, formData, {
			params: {
				jObject,
			},
		})
		.then((r) => {
			handleSuccess(r);
		})
		.catch((e) => {
			handleError(e);
			console.log('Error: ', e);
		});
};

export { handleApiCall, handleFormApiCall };

export default callApi;
